import axios from "axios"
import { ROUTER_STATS_HOST, TransactionStatus } from ".."

export const getTxStatus = async (txHash:string,networkId:string
    ):Promise<TransactionStatus|undefined>=>{
    const params={
        txHash,
        networkId
    }
    const pathUrl = `${ROUTER_STATS_HOST}/api/status`
    try {
        const res= await axios.get(pathUrl, { params })
        return res.data
    } catch (e) {
        console.error(`Fetching Transaction Status: ${e}`)
        return undefined
    }
}